/* src/app/shared/components/ag-filter-drop-down/ag-filter-drop-down.component.scss */
.pill {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  height: 24px;
  cursor: pointer;
}
.pill .numberOfFiltersActive {
  display: flex;
  height: 20px;
  padding: 0px 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background: #dfdfdf;
}
.drop-down {
  flex-direction: column;
  width: 250px;
  border-radius: 12px;
  background-color: transparent;
  border: 1px solid transparent;
  position: absolute;
  top: 32px;
  left: -16px;
  z-index: 2;
  max-height: 0px;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    background-color 0.3s ease-in-out,
    border 0.3s ease-in-out;
}
.drop-down .filter {
  padding: 8px 0px;
  display: flex;
  flex-direction: column;
}
.drop-down .button-area {
  width: 100%;
  border-top: 1px solid #dfdfdf;
  padding: 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}
.show-drop-down {
  max-height: 1000px;
  border: 1px solid #dfdfdf;
  background-color: #ffffff;
  box-shadow: 1px 2px 10px 0px rgba(34, 34, 34, 0.1);
}
.outputList {
  padding: 8px 16px;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background-color: #ffffff;
}
.outputList:hover {
  background-color: #f2f2f2;
}
.spandOutput {
  padding: 8px 16px;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
}
.spandOutput .spandInput {
  display: flex;
  height: 56px;
  min-height: 40px;
  width: 97px;
  padding: 13px 16px;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  align-self: stretch;
  border: 1px solid transparent;
  border-radius: 12px;
  outline: none;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  background-color: #f2f2f2;
  color: #222222;
}
.spandOutput .spandInput::-webkit-outer-spin-button,
.spandOutput .spandInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.spandOutput .spandInput[type=number] {
  -moz-appearance: textfield;
}
.spandOutput .focused {
  border: 1px solid #222222;
  color: #222222;
}
.filter-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 94px !important;
  border-radius: 16px;
  background-color: #f2f2f2;
  padding: 16px;
  cursor: pointer;
  position: relative;
}
.filter-button img {
  width: 20px;
  height: 20px;
}
.filter-button:hover {
  opacity: 0.8;
}
.filters-active {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -2px;
  right: -2px;
  border-radius: 50%;
  background-color: #e4d7f3;
}
/*# sourceMappingURL=ag-filter-drop-down.component.css.map */
